<template>
  <div class="modern-dashboard">

    <!-- Main Content Grid -->
    <div class="content-grid">
      

      <!-- Top Latest Usage Devices -->
    <div class="dashboard-card" data-aos="fade-up" data-aos-delay="100">
      <div class="card-header">
        <h5 class="card-title">
          <i class="fas fa-clock"></i> Daily Usage Devices
        </h5>
        <a href="#" class="view-all-link">View All →</a>
      </div>
      <div class="card-body">
        <div class="device-list">
          <div 
            v-for="(device, index) in todaysAppUsagesByKids" 
            :key="'device-' + index" 
            class="device-item"
          >
            <div class="device-rank">{{ index + 1 }}</div>
            <div class="device-info">
              <h6 class="device-profile">{{ device.profile_name || 'No Profile' }}</h6>
              <p class="device-serial">Serial: {{ device.serialNumber }}</p>
              <p class="device-parent">User: 
                <a href="javascript:void(0)" @click="ByPassUserLogin(device.parent_email)">
                {{ device.parent_email || 'N/A' }}
                </a>
            </p>
              <p class="device-parent text-warning">Used Time: {{ device.totalTimeInMinute || 'N/A' }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Inactive Devices Card -->
    <div class="dashboard-card" data-aos="fade-up" data-aos-delay="100">
      <div class="card-header">
        <h5 class="card-title">
          <i class="fas fa-clock"></i> Weekly Usages ({{ startDate }} - {{ endDate }})
        </h5>
        <a href="#" class="view-all-link">View All →</a>
      </div>
      <div class="card-body">
        <div class="device-list">
          <div 
            v-for="(device, index) in currentWeekAppUsagesByKids" 
            :key="device._id" 
            class="device-item"
          >
            <div class="device-rank">{{ index + 1 }}</div>
            <div class="device-info">
              <h6 class="device-profile">{{ device.profile_name || 'No Profile' }}</h6>
              <p class="device-serial">Serial: {{ device.serialNumber }}</p>
              <p class="device-parent">User: 
                <a href="javascript:void(0)" @click="ByPassUserLogin(device.parent_email)">
                {{ device.parent_email || 'N/A' }}
                </a>
              </p>
              <p class="device-parent text-warning">Used Time: {{ device.totalTimeInMinute || 'N/A' }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Inactive Devices Card -->
    <div class="dashboard-card" data-aos="fade-up" data-aos-delay="100">
      <div class="card-header">
        <h5 class="card-title">
          <i class="fas fa-clock"></i> Inactive Devices
        </h5>
        <a href="#" class="view-all-link">View All →</a>
      </div>
      <div class="card-body">
        <div class="device-list">
          <div 
            v-for="(device, index) in devicesWithNoUsageInLast7Days" 
            :key="device._id" 
            class="device-item"
          >
            <div class="device-rank">{{ index + 1 }}</div>
            <div class="device-info">
              <h6 class="device-profile">{{ device.profile_name || 'No Profile' }}</h6>
              <p class="device-serial">Serial: {{ device.serialNumber }}</p>
              <p class="device-parent">User: 
                <a href="javascript:void(0)" @click="ByPassUserLogin(device.parent_email)">
                {{ device.parent_email || 'N/A' }}
                </a>
                </p>
              <p class="device-parent text-warning">Used Date: {{ device.lastUsageDate || 'N/A' }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Never Used Devices Card -->
    <div class="dashboard-card" data-aos="fade-up" data-aos-delay="100">
      <div class="card-header">
        <h5 class="card-title">
          <i class="fas fa-clock"></i> Never Used Devices
        </h5>
        <a href="#" class="view-all-link">View All →</a>
      </div>
      <div class="card-body">
        <div class="device-list">
          <div 
            v-for="(device, index) in usersWithNoAppUsageEver" 
            :key="device._id" 
            class="device-item"
          >
            <div class="device-rank">{{ index + 1 }}</div>
            <div class="device-info">
              <p class="device-parent">User: 
                <a href="javascript:void(0)" @click="ByPassUserLogin(device.email)">
                {{ device.email || 'N/A' }}
                </a>
            </p>
              <p class="device-parent">Profile Name: {{ device.profile_name || 'N/A' }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    </div>
  </div>
</template>

<script>
import DashboardService from "../../services/SuperAdmin/Kids/DashboardService";
import UsersDataService from "../../services/SuperAdmin/UsersDataService";
export default {
  data() {
    return {
      todaysAppUsagesByKids: [],
      currentWeekAppUsagesByKids: [],
      devicesWithNoUsageInLast7Days: [],
      usersWithNoAppUsageEver: [],
      startDate: null,
      endDate: null,
    }
  },
  mounted() {
  },
  methods: {
    handleImageError(event) {
      event.target.src = 'https://via.placeholder.com/48x48/9CA3AF/FFFFFF?text=📱';
    },
    getWingioAppUsagesDashboardDetail() {
      let data = { selectedPeriod: this.selectedPeriod};
        DashboardService.getWingioAppUsagesDashboardDetail(data)
          .then((response) => {
            this.todaysAppUsagesByKids = response.data.data.todaysAppUsagesByKids
            this.currentWeekAppUsagesByKids = response.data.data.currentWeekAppUsagesByKids
            this.devicesWithNoUsageInLast7Days = response.data.data.devicesWithNoUsageInLast7Days
            this.usersWithNoAppUsageEver = response.data.data.usersWithNoAppUsageEver
            this.startDate = response.data.data.startDate
            this.endDate = response.data.data.endDate
            this.$toast.success(response.data.respones_msg);
          }).catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
          });
    },
    statusClass(status) {
      if (status === 'Never Used') return 'status-never-used';
      if (status === 'Not Recent') return 'status-not-recent';
      return 'status-active';
    },
    ByPassUserLogin(email) {
      UsersDataService.ByPassUserLogin({ email })
        .then((response) => {
          window.open(
            "https://parent.mywingio.com?token=" + response.data.data.token,
            "_blank"
          );
        })
        .catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
  },
  beforeMount() {
    this.getWingioAppUsagesDashboardDetail();
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css');

.modern-dashboard {
  font-family: 'Inter', sans-serif;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
  padding: 2rem;
}

/* Header */
.dashboard-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 2.5rem;
  border-radius: 20px;
  margin-bottom: 2rem;
  box-shadow: 0 20px 40px rgba(102, 126, 234, 0.3);
  backdrop-filter: blur(10px);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}

.dashboard-title {
  color: white;
  font-size: 2.2rem;
  font-weight: 800;
  margin: 0 0 0.5rem 0;
  letter-spacing: -0.02em;
}

.dashboard-subtitle {
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
  font-size: 1.1rem;
  font-weight: 400;
}

.date-filter {
  display: flex;
  gap: 1rem;
}

.filter-select {
  padding: 12px 20px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.15);
  color: white;
  font-weight: 500;
  cursor: pointer;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.filter-select:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
}

.filter-select option {
  color: #333;
  background: white;
}

/* Stats Grid */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.stat-card {
  background: rgba(255, 255, 255, 0.95);
  padding: 2rem;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 1.5rem;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.stat-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
}

.stat-icon {
  width: 70px;
  height: 70px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;
}

.stat-card:hover .stat-icon {
  transform: scale(1.1);
}

.stat-icon-primary { background: linear-gradient(135deg, #667eea, #764ba2); color: white; }
.stat-icon-success { background: linear-gradient(135deg, #10b981, #059669); color: white; }
.stat-icon-warning { background: linear-gradient(135deg, #f59e0b, #d97706); color: white; }
.stat-icon-info { background: linear-gradient(135deg, #3b82f6, #2563eb); color: white; }

.stat-value {
  font-size: 2.5rem;
  font-weight: 800;
  color: #1e293b;
  margin: 0;
  line-height: 1;
}

.stat-label {
  color: #64748b;
  font-size: 1rem;
  margin: 0.5rem 0 0.25rem 0;
  font-weight: 500;
}

.stat-change {
  font-size: 0.9rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.stat-change.positive { color: #10b981; }
.stat-change.negative { color: #ef4444; }

/* Content Grid */
.content-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(480px, 1fr));
  gap: 1.5rem;
  max-width: 1400px;
  margin: 0 auto;
}

.full-width { grid-column: 1 / -1; }

/* Dashboard Cards */
.dashboard-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: all 0.4s ease;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.dashboard-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
}

.card-header {
  padding: 1.5rem 2rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: #1e293b;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.card-subtitle {
  margin: 0.25rem 0 0 0;
  color: #64748b;
  font-size: 0.95rem;
  font-weight: 400;
}

.view-all-link {
  color: #667eea;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.9rem;
  transition: color 0.3s ease;
}

.view-all-link:hover {
  color: #764ba2;
}

.card-body {
  padding: 2rem;
}

.chart-container {
  height: 300px;
  position: relative;
}

.small-chart {
  height: 250px !important;
}

/* App List */
.app-list {
  max-height: 400px;
  overflow-y: auto;
}

.app-item {
  display: flex;
  align-items: center;
  padding: 1rem 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.app-item:hover {
  background: rgba(102, 126, 234, 0.05);
  padding-left: 1rem;
  border-radius: 12px;
  margin: 0 -1rem;
}

.app-item:last-child {
  border-bottom: none;
}

.app-rank {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.875rem;
  color: white;
  margin-right: 1rem;
  flex-shrink: 0;
}

.app-rank.rank-installed { background: linear-gradient(135deg, #0b28f5, #061ed9); }
.app-rank.rank-requested { background: linear-gradient(135deg, #f59e0b, #d97706); }
.app-rank.rank-used { background: linear-gradient(135deg, #ef4444, #dc2626); }
.app-rank.rank-parent { background: linear-gradient(135deg, #10b981, #059669); }
.app-rank.rank-kid { background: linear-gradient(135deg, #3b82f6, #2563eb); }

.app-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  margin-right: 1rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  flex-shrink: 0;
}

.app-info {
  flex: 1;
  min-width: 0;
}

.app-name {
  margin: 0 0 0.25rem 0;
  font-size: 1rem;
  font-weight: 600;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.app-category {
  margin: 0;
  color: #64748b;
  font-size: 0.85rem;
  font-weight: 500;
}

.app-stat {
  text-align: right;
  flex-shrink: 0;
}

.stat-number {
  display: block;
  font-size: 1.1rem;
  font-weight: 700;
  color: #1e293b;
  line-height: 1;
}

.stat-label {
  font-size: 0.8rem;
  color: #9ca3af;
  font-weight: 500;
}

/* Rating Stars */
.rating-stars {
  display: flex;
  gap: 0.25rem;
  margin-top: 0.25rem;
}

.rating-stars i {
  font-size: 0.9rem;
  color: #d1d5db;
}

.rating-stars i.filled {
  color: #fbbf24;
}

/* Quick Stats */
.quick-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}

.quick-stat-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  border-radius: 12px;
  transition: transform 0.3s ease;
}

.quick-stat-item:hover {
  transform: translateX(5px);
}

.quick-stat-icon {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  flex-shrink: 0;
}

.quick-stat-icon { background: #e8f5e9; }
.quick-stat-icon.pending { background: #fff3e0; }
.quick-stat-icon.denied { background: #ffebee; }
.quick-stat-icon.active { background: #e3f2fd; }

.quick-stat-content h4 {
  margin: 0 0 0.25rem 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
}

.quick-stat-content p {
  margin: 0;
  color: #64748b;
  font-size: 0.9rem;
  font-weight: 500;
}

/* Responsive */
@media (max-width: 768px) {
  .modern-dashboard {
    padding: 1rem;
  }
  
  .header-content {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
  
  .stats-grid {
    grid-template-columns: 1fr;
  }
  
  .content-grid {
    grid-template-columns: 1fr;
  }
  
  .card-header {
    flex-direction: column;
    gap: 0.5rem;
    text-align: center;
  }
}

.dashboard-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.1);
  padding: 20px;
  margin-bottom: 30px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.view-all-link {
  font-size: 14px;
  color: #007bff;
  text-decoration: none;
}

.device-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.device-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f9f9f9;
  border-radius: 8px;
  padding: 12px 15px;
  transition: transform 0.2s;
}

.device-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.device-rank {
  font-size: 18px;
  font-weight: 700;
  color: #555;
  width: 35px;
  text-align: center;
}

.device-info {
  flex: 1;
  margin-left: 10px;
}

.device-profile {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}

.device-serial,
.device-parent {
  font-size: 13px;
  color: #777;
  margin: 2px 0;
}

.device-date {
  text-align: right;
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.device-date strong {
  display: block;
  font-size: 15px;
  color: #000;
}

.device-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.device-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f9f9f9;
  border-radius: 8px;
  padding: 10px 15px;
  transition: transform 0.2s;
}

.device-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.device-rank {
  font-size: 18px;
  font-weight: 700;
  color: #555;
  width: 35px;
  text-align: center;
}

.device-info {
  flex: 1;
  margin-left: 10px;
}

.device-profile {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}

.device-serial,
.device-parent,
.device-last-used {
  font-size: 13px;
  color: #777;
  margin: 2px 0;
}

.device-status span {
  padding: 4px 10px;
  border-radius: 12px;
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
}

.status-never-used {
  background: #ffdddd;
  color: #d9534f;
}

.status-not-recent {
  background: #fff4e5;
  color: #f0ad4e;
}

.status-active {
  background: #e6f7ff;
  color: #0275d8;
}

</style>
